var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import { updateUserSettings } from '../api';
import ApiContext from '../contexts/apiContext';
import UserContext from '../contexts/userContext';
var MIN_VALUE = 0;
var MAX_VALUE = 1;
var STEP = 0.1;
var marks = [
    {
        label: '0.0',
        value: 0
    },
    {
        label: '0.1',
        value: 0.1
    },
    {
        label: '0.2',
        value: 0.2
    },
    {
        label: '0.3',
        value: 0.3
    },
    {
        label: '0.4',
        value: 0.4
    },
    {
        label: '0.5',
        value: 0.5
    },
    {
        label: '0.6',
        value: 0.6
    },
    {
        label: '0.7',
        value: 0.7
    },
    {
        label: '0.8',
        value: 0.8
    },
    {
        label: '0.9',
        value: 0.9
    },
    {
        label: '1.0',
        value: 1
    }
];
var TemperatureSelector = function () {
    var _a;
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var _b = useContext(UserContext), userSettings = _b.userSettings, setUserSettings = _b.setUserSettings;
    var _c = useState((_a = userSettings === null || userSettings === void 0 ? void 0 : userSettings.temperature) !== null && _a !== void 0 ? _a : 1), temperature = _c[0], setTemperature = _c[1];
    var _d = useState(false), snackbarOpen = _d[0], setSnackbarOpen = _d[1];
    var handleTemperatureChange = function (_, value) { return __awaiter(void 0, void 0, void 0, function () {
        var newTemperature, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newTemperature = Array.isArray(value) ? value[0] : value;
                    setTemperature(newTemperature);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateUserSettings(apiBaseUrl, { temperature: newTemperature })];
                case 2:
                    _a.sent();
                    setUserSettings(userSettings ? __assign(__assign({}, userSettings), { temperature: newTemperature }) : { temperature: newTemperature });
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSnackbarClose = function (_, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { height: "200px", alignSelf: "end", pt: 2, children: _jsx(Tooltip, { title: "Temperature. Default: 1.0", children: _jsx(Slider, { defaultValue: temperature, step: STEP, min: MIN_VALUE, max: MAX_VALUE, marks: marks, onChange: handleTemperatureChange, orientation: "vertical", size: "small", valueLabelDisplay: "on" }) }) }), _jsx(Snackbar, { anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, open: snackbarOpen, autoHideDuration: 6000, onClose: handleSnackbarClose, message: "Your temperature preferences have been saved; existing messages won't be affected by this change" })] }));
};
export default TemperatureSelector;
